import { readLabelSets } from './read'

export const labelSets = {
  readCollection: readLabelSets,
}
